export const pluralizeCount = (items, title, plural = null) => {
  if (!items?.length){
    return '';
  }
  if (items.length === 1){
      return `1 ${title}`;
  }
  return `${items.length} ` + (plural || `${title}s`);
};

export function processIssueStatsForCategory(issueList, filterCategories) {
  let processedIssues = {
    'count_low': 0,
    'count_medium': 0,
    'count_high': 0,
    'count': 0,
    'levelNumber': 0,
    'level': 'low',
    'route': {
      'name': '',
      'params': {},
    }
  }
  if (!issueList) {
    return processedIssues;
  }
  const LEVEL_MAPPING = {
    'low': 1,
    'medium': 2,
    'high': 3,
  }
  Object.keys(issueList).forEach((cat, value) => {
    if (filterCategories.includes(cat)) {


      let catIssues = issueList[cat];
      processedIssues.count_low += catIssues['low']
      processedIssues.count_medium += catIssues['medium']
      processedIssues.count_high += catIssues['high']

      if (catIssues['high'] && LEVEL_MAPPING['high'] > processedIssues.levelNumber) {
        processedIssues.level = 'high'
        processedIssues.levelNumber = LEVEL_MAPPING['high']
        processedIssues.route.name = cat;
      } else if (catIssues['medium'] && LEVEL_MAPPING['medium'] > processedIssues.levelNumber) {
        processedIssues.level = 'medium'
        processedIssues.levelNumber = LEVEL_MAPPING['medium']
        processedIssues.route.name = cat;
      } else if (catIssues['low'] && LEVEL_MAPPING['low'] > processedIssues.levelNumber) {
        processedIssues.level = 'low'
        processedIssues.levelNumber = LEVEL_MAPPING['low']
        processedIssues.route.name = cat;
      }
    }

  });

  if (processedIssues.level === 'low') {
    processedIssues.count = processedIssues.count_low;
  } else if (processedIssues.level === 'medium') {
    processedIssues.count = processedIssues.count_medium;
  }
  if (processedIssues.level === 'high') {
    processedIssues.count = processedIssues.count_high;
  }

  return processedIssues;
}

export function processFlatIssueStatsForCategory(issueList, filterCategories) {
  let processedIssues = {
    'count_low': 0,
    'count_medium': 0,
    'count_high': 0,
    'count': 0,
    'level': 'none',
    'route': {
      'name': '',
      'params': {},
    }
  }

  if (!issueList) {
    return processedIssues
  }

  const LEVEL_MAPPING = {
    'none': 0,
    'low': 1,
    'medium': 2,
    'high': 3,
  }
  for (let cat of filterCategories) {
    if (issueList[cat.name]) {
      processedIssues[`count_${cat.level}`] += issueList[cat.name];
      if (LEVEL_MAPPING[cat.level] > LEVEL_MAPPING[processedIssues.level]) {
        processedIssues.level = cat.level;
        processedIssues.route.name = cat.route
      }
    }
  }

  return processedIssues;
}

export function getProgressColor(score) {
  if (score >= 80 || score === 0) return "#22c55e"; // Success/Green
  if (score >= 60) return "#f59e0b"; // Warning/Orange
  return "#ef4444"; // Danger/Red
}